module.exports = __webpack_public_path__ + "static/media/IMG_3563.5a3c8b1f.jpg";